import classNames from 'classnames'
import {useObjectHack} from 'quickstart/hooks'
import type {ComponentProps, MouseEvent} from 'react'
import S from '../Link/styles.module.scss'

export const UniversalLink = ({
  href,
  onClick,
  target,
  className,
  ...rest
}: ComponentProps<'a'>) => {
  const link = (
    <a
      className={classNames(S.unstyled, className)}
      href={href || '#'}
      // https://web.dev/external-anchors-use-rel-noopener/
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      target={target}
      {...rest}
      onClick={
        onClick && href
          ? onClick
          : href
            ? undefined
            : (e: MouseEvent<HTMLAnchorElement>) => {
                onClick?.(e)
                e.preventDefault()
              }
      }
    />
  )
  return useObjectHack('a', link)
}
